'use strict';

var React = require('react');

module.exports = React.createClass({
	displayName: 'ArticleMediaText',

	propTypes: {
		article: React.PropTypes.object
	},

	render: function () {
		var article = this.props.article;

		if (!article) {
			return false;
		}

		var hasVideo = article.clips && article.clips.length;
		var coverPhotographer;
		var coverInfo;

		if(hasVideo && article.clips && article.clips[0]) {
			coverInfo = article.clips[0].picture;
		} else {
			coverInfo = article.cover;
		}
	

		if (!coverInfo) {
			return (
				<div className="svtse_editorial__media-text--empty"></div>
			);
		}
		
		coverPhotographer = coverInfo.photographer ? '' : '';

		if (!coverInfo.altText && !coverPhotographer) {
			return (
				<div className="svtse_editorial__media-text--empty"></div>
			);
		}

		return (
			<div className="svtse_editorial__media-text">
		
				<div className="svtse_editorial__media-alt-text-col">
					<figcaption className="svtse_editorial__media-alt-text">
						{coverInfo.altText}
					</figcaption>
				</div>

				<div className="svtse_editorial__media-byline-col">
					<p className="svtse_editorial__media-byline">
						{coverPhotographer}
					</p>
				</div>
			</div>
		);
	}
});



/** WEBPACK FOOTER **
 ** ./app/components/Editorial/EditorialMediaText.jsx
 **/